
import { Vue, Component } from 'vue-property-decorator';
import Api from '@/services/api';

@Component
export default class ChangePassword extends Vue {
  public formTitle = 'تغییر رمز عبور';
  public editedItem = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  };
  public breadcrumbItems = [
    {
      text: 'صفحه اصلی',
      disabled: false,
      href: '/'
    },
    {
      text: 'تغییر رمز عبور',
      disabled: true,
      href: ''
    }
  ];

  async changePassword() {
    const isValid = (this.$refs.Observer as any).validate();
    if (!isValid) {
      return;
    }
    this.$showLoading();
    await Api.changePassword(this.editedItem.oldPassword, this.editedItem.newPassword, this.editedItem.confirmPassword).then((response: any) => {
      this.$showNotification('success', 'رمز عبور با موفقیت تغییر یافت.');
      this.$router.replace({ name: 'Home' });
      this.$hideLoading();
    });
  }
}
